<template>
    <transition name="el-fade-in">
        <div
            v-if="visible"
            @click.stop="handleClick"
            :style="{'left': styleLeft, 'right': styleRight, 'bottom': styleBottom, color: color, opacity: opacity_}"
            class="stickpop">
            <slot>
                <el-icon name="delete"></el-icon>
            </slot>
        </div>
    </transition>
</template>

<script>
    import throttle from 'throttle-debounce/throttle';

    export default {
        name: 'StickPop',
        props: {
            visibilityHeight: {
                type: Number,
                default: 200
            },
            target: [String],
            left: {
                type: Number,
                default: null
            },
            right: {
                type: Number,
                default: null
            },  // left 和 right 是互斥的，如果设置了 right 那么 left 就必须是 null
            bottom: {
                type: Number,
                default: 40
            },
            color: '#000000',
            opacity: false
        },

        data() {
            return {
                el: null,
                container: null,
                visible: false,
                opacity_: 1,
            };
        },

        computed: {
            styleBottom() {
                return `${this.bottom}px`;
            },
            styleLeft() {
                return this.left === undefined || this.left === null ? 'unset' : `${this.left}px`
            },
            styleRight() {
                if (this.right !== null){
                    this.left = null
                }
                return this.right === undefined || this.right === null ? 'unset' : `${this.right}px`
            }
        },

        mounted() {
            console.log('StickPop mounted executing')
            this.opacity ? this.opacity_ = 0.8 : this.opacity_ = 1;
            this.init();
            this.throttledScrollHandler = throttle(300, this.onScroll);
            this.container.addEventListener('scroll', this.throttledScrollHandler);
            console.log('StickPop mounted, scroll event added');
        },

        beforeDestroy() {
            this.container.removeEventListener('scroll', this.throttledScrollHandler);
        },

        methods: {
            init() {
                this.container = document;
                this.el = document.documentElement;
                if (this.target) {
                    this.el = document.querySelector(this.target);
                    if (!this.el) {
                        throw new Error(`target is not existed: ${this.target}`);
                    }
                    this.container = this.el;
                }
            },
            onScroll() {
                /*
                // fix Android bug, Element 使用 document.documentElement 计算 scrollTop 的方式在 Android 小米上不生效，使用通用的方法 window.pageYOffset
                // TODO 但是 Element 的 el-backtop 组件如何重构？现在的想法是，其实 backtop 可有可无！干脆在 Android 上就放弃不用了得了。
                const scrollTop = this.el.scrollTop;
                this.visible = scrollTop >= this.visibilityHeight;
                 */
                this.visible = window.pageYOffset >= this.visibilityHeight;
                // console.log(`StickPop onScroll, current scroll top: ${scrollTop}, window.pageYOffset: ${window.pageYOffset}`);
            },
            handleClick(e) {
                this.$emit('click', e);
            },
        }
    };
</script>

<style>
    .stickpop{
        position:fixed;
        background-color:#FFF;
        width:40px;
        height:40px;
        border-radius:50%;
        display:-webkit-box;
        display:-ms-flexbox;
        display:flex;
        -webkit-box-align:center;
        -ms-flex-align:center;
        align-items:center;
        -webkit-box-pack:center;
        -ms-flex-pack:center;
        justify-content:center;
        font-size:20px;
        -webkit-box-shadow:0 0 6px rgba(0,0,0,.12);
        box-shadow:0 0 6px rgba(0,0,0,.12);
        cursor:pointer;
        z-index:5
    }
</style>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/stickpops/StickPop.vue